import React from 'react';
import { TextInputSkeleton } from 'carbon-components-react';

type Props = {
  isLoading: boolean;
  otherClassName?: string;
};

const AuthorisationFormItem: React.FC<Props> = ({
  isLoading,
  otherClassName,
  children
}) => {
  return (
    <section
      className={`add-user-form-item${
        otherClassName ? ` ${otherClassName}` : ''
      }`}
    >
      {isLoading ? <TextInputSkeleton /> : children}
    </section>
  );
};

export default AuthorisationFormItem;
